import { createBrowserHistory } from 'history';
import * as React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import HttpsRedirect from 'react-https-redirect';
import { Redirect, Route, Router, Switch } from 'react-router';
import './App.css';
import { DashboardWithGlobalContext } from './components/Dashboard/Dashboard';
import { HomePageWithRouter } from './components/HomePage/HomePage';
import { PaymentWithGlobalContext } from './components/Payment/Payment';
import { ProfileWithGlobalContext } from './components/Profile/Profile';
import { ProjectWithGlobalContext } from './components/Project/Project';
import { ProjectCreationWithGlobalContext } from './components/Project/ProjectCreation';
import { FooterWithRouter } from './components/shared/Footer';
import { HeaderWithGlobalContext } from './components/shared/Header/Header';
import { GlobalContext } from './context/global.context';
import { GlobalState } from './context/global.state';

const history = createBrowserHistory();

export class App extends React.Component {
  public render() {
    return (
       <HttpsRedirect>
      <Router history={history}>
        <GlobalState>
          <HeaderWithGlobalContext />
          <Switch>
            <Route
              exact={true}
              path='/'
              render={() => (
                <GlobalContext.Consumer>
                  {(context) =>
                   !localStorage.getItem('beadvize-IsCreating') &&
                     context.user && !context.isCreating ? (
                      <Redirect to='/dashboard/' />
                    ) : (
                      <HomePageWithRouter />
                    )
                  }
                </GlobalContext.Consumer>
              )}
            />
            <Route
              exact={true}
              path='/dashboard/'
              component={DashboardWithGlobalContext}
            />
            <Route
              exact={true}
              path='/project/create'
              component={ProjectCreationWithGlobalContext}
            />
            <Route path='/project/:id' component={ProjectWithGlobalContext} />
            <Route path='/profile/' component={ProfileWithGlobalContext} />
            <Route path='/payments/' component={PaymentWithGlobalContext} />
          </Switch>
          <FooterWithRouter />
        </GlobalState>
      </Router>
       </HttpsRedirect>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx